import { Component } from '@angular/core';
import { FEEDBACK_INCENTIVE, FEE_PERCENTAGE, MINIMUM_FEE } from '@curbnturf/entities';

@Component({
  selector: 'curbnturf-terms-pricing-payouts-fees',
  templateUrl: './terms-pricing-payouts-fees.component.html',
  styleUrls: ['./terms-pricing-payouts-fees.component.scss'],
  standalone: true,
})
export class TermsPricingPayoutsFeesComponent {
  feedbackIncentive = FEEDBACK_INCENTIVE;
  minimumFee = MINIMUM_FEE;
  percentageFee = FEE_PERCENTAGE * 100;
}
